export default __webpack_public_path__ + "static/media/logo_facepay_mobile.85f34bbf.svg";